export const ALT_OPACITY = 0.25;

export const CHORD_ROOT_COLOR = '1-STRONG' as const;
export const CHORD_TONE_COLOR = '2-STRONG' as const;

export const SCALE_ROOT_COLOR = '1-LIGHT' as const;
export const SCALE_TONE_COLOR = '2-LIGHT' as const;

export type SecondInterval = 'b2' | '2' | '#2';
export type ThirdInterval = 'b3' | '3';
export type FourthInterval = 'b4' | '4' | '#4';
export type FifthInterval = 'b5' | '5' | '#5';
export type SixthInterval = 'b6' | '6';
export type SeventhInterval = 'bb7' | 'b7' | '7';
